module.exports = {"pagination":{"DescribeRemediationExceptions":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"DescribeRemediationExecutionStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"RemediationExecutionStatuses"},"GetResourceConfigHistory":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"configurationItems"},"SelectAggregateResourceConfig":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/config-2014-11-12.paginators.json
// module id = 644
// module chunks = 2